module.exports = __webpack_public_path__ + "img/worldCup.38635602.jpg";